import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ums-menu",
  "use": "icon-ums-menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-ums-menu\"><path d=\"M919.2448 429.312a55.4496 55.4496 0 0 0-51.2-4.5568v-224.768a105.984 105.984 0 0 0-105.3696-106.496H272.4352a106.0352 106.0352 0 0 0-105.3696 106.496v227.3792l-5.12-2.304a55.552 55.552 0 0 0-53.248 4.096 56.32 56.32 0 0 0-25.7536 47.5136v357.888a111.104 111.104 0 0 0 110.3872 111.616h641.5872a111.104 111.104 0 0 0 110.336-111.616V476.9792a56.32 56.32 0 0 0-26.0096-47.616zM228.5568 199.9872a44.544 44.544 0 0 1 43.8784-45.056h490.0864a44.544 44.544 0 0 1 43.9296 45.056v252.8256l-288.5632 132.5056-289.3824-130.304v-254.976z m655.36 634.88a49.6128 49.6128 0 0 1-48.9472 50.176H193.3312a49.664 49.664 0 0 1-48.9472-50.4832V484.5056l361.0112 162.56a30.72 30.72 0 0 0 25.6 0l352.9728-162.048-0.1024 349.8496z\" p-id=\"1627\" /><path d=\"M695.2448 346.2144a30.72 30.72 0 0 0-30.72-30.72h-294.4a30.72 30.72 0 1 0 0 61.44h294.4a30.72 30.72 0 0 0 30.72-30.72z\" p-id=\"1628\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ums-menu.svg
// module id = sr5k
// module chunks = 41